export const pricingData = {
	yearly: [
		{
			title: "Personal",
			features: [
				"Up to 3 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$29",
			salePrice: "$19",
			link: "https://pickplugins.lemonsqueezy.com/buy/0ae63e9a-ce87-4683-9514-9626ae4c38b9?enabled=294490",
		},
		{
			title: "Plus",
			features: [
				"Up to 10 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$75",
			salePrice: "$49",
			link: "https://pickplugins.lemonsqueezy.com/buy/751c5c9a-eb92-48df-b41c-cf02c0afe9f2?enabled=294492",
		},

		{
			title: "Agency",
			features: [
				"Up to 500 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$149",
			salePrice: "$99",
			link: "https://pickplugins.lemonsqueezy.com/buy/dc476d99-f2fe-499d-9f5c-25c1b56136fa?enabled=294496",
		},
	],
	lifetime: [
		{
			title: "Personal",
			features: [
				"Up to 3 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$99",
			salePrice: "$49",
			link: "https://pickplugins.lemonsqueezy.com/buy/ca27a51c-5da2-459d-82d0-ba61bb82878e?enabled=294491",
		},
		{
			title: "Plus",
			features: [
				"Up to 10 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$149",
			salePrice: "$99",
			link: "https://pickplugins.lemonsqueezy.com/buy/1e500b1d-727f-45f7-8ee1-86fe8cec8cf7?enabled=294493",
		},

		{
			title: "Agency",
			features: [
				"Up to 500 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$199",
			salePrice: "$149",
			link: "https://pickplugins.lemonsqueezy.com/buy/54071a32-bce5-4e55-afcf-9fa66223ab07?enabled=294497",
		},
	],
};
